import { Styles } from './styles';
import React from 'react';
import { PillMenu } from '../PillMenu/PillMenu';
import { Text } from 'atoms/Text/Text';

export const AreaOfSpecialisationFilter = () => (
  <div>
    <Styles.Heading>
      <Text.body1>Filter by specialization</Text.body1>
    </Styles.Heading>
    <PillMenu attribute="areaOfSpecialisation" />
  </div>
);
